<template>
  <layout-horizontal>

    <router-view />
    <template #footer>
      <b-card
        class="mb-0 border-radius-0"
        bg-variant="dark"
        text-variant="white"
      >
        <b-card-body>
          <b-row>
            <b-col
              md="4"
              class="text-center px-5"
            >
              <b-img
                :src="appLogoImage"
                alt="logo"
                class="m-auto"
                style="width: 110px"
              />
              <div class="mt-1 font-medium-5">
                {{ $t("Agency for Innovative Development of the Republic of Uzbekistan") }}
              </div>
              <div class="mt-1">
                {{ $t('© {year} All rights reserved', { year: new Date().getFullYear()}) }}
              </div>
            </b-col>
            <b-col
              md="4"
              class="text-center px-5 font-medium-3 align-self-center"
            >
              <hr class="d-xl-none">
              <div>
                <feather-icon
                  icon="PhoneIcon"
                  size="20"
                />
                {{ $t('Phone') }}: +71 203-32-23 ({{ $t('Extension') }}: 152)
              </div>

              <div class="mt-2">
                <feather-icon
                  icon="AtSignIcon"
                  size="20"
                />
                {{ $t('Email') }}: {{ email }}
              </div>
              <div class="mt-2">
                <feather-icon
                  icon="MapIcon"
                  size="20"
                />
                {{ $t('Address') }}: {{ $langName(address) }}
              </div>
            </b-col>
            <b-col
              md="4"
              class="text-center px-5 font-medium-3 align-self-center"
            >
              <hr class="d-xl-none">
              {{ $t('Social networks') }}
              <div class="mt-2">
                <feather-icon
                  icon="SendIcon"
                  size="35"
                  class="mr-1 icon-cicle"
                />
                <b-link :href="socialNetworks.telegram">
                  Telegram
                </b-link>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </template>
    <template #navbar="{ toggleVerticalMenuActive }">
      <app-navbar-horizontal-layout :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>
  </layout-horizontal>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BImg, BLink,
} from 'bootstrap-vue'

import { $themeConfig } from '@themeConfig'
import LayoutHorizontal from '@core/layouts/layout-horizontal/LayoutHorizontal.vue'
import AppNavbarHorizontalLayout from '@/layouts/horizontal/AppNavbarHorizontalLayout.vue'

export default {
  components: {
    LayoutHorizontal,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BLink,
    AppNavbarHorizontalLayout,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },
  setup() {
    // App Name
    const {
      appName, appLogoImage, address, email, socialNetworks,
    } = $themeConfig.app
    return {
      appName,
      appLogoImage,
      address,
      email,
      socialNetworks,
    }
  },
}
</script>
<style>
 .border-radius-0 {
   border-radius: 0 !important;
 }
 .icon-cicle {
   border: solid 1px;
   padding: 6px;
   border-radius: 50%;
 }
</style>
